/** @format */

import { call, put, takeLatest } from 'redux-saga/effects';
import { updateBrokerService } from 'services/apiService';
import * as actionTypes from 'stateContainer/action-types';
import { push } from 'connected-react-router';

function* workerSaga({ payload }) {
  try {
    const response = yield call(updateBrokerService, payload);
    if (response.data.status == 'success') {
      yield put({
        type: actionTypes.UPDATE_BROKER_SUCCESS,
        payload
      });
    } else {
      throw new Error('Fetch broker failed');
    }
  } catch (error) {
    yield put({ type: actionTypes.UPDATE_BROKER_ERROR, error });
    if (error.response.data.error == 'NotAuthorized') {
      yield put(push({ type: actionTypes.LOGOUT_REQUESTED }));
      yield put(push('/'));
    }
  }
}

export function* updateBrokerSaga() {
  yield takeLatest(actionTypes.UPDATE_BROKER_REQUESTED, workerSaga);
}
